import deepFreeze from "deep-freeze";
import Table2Borders from "./Table2Borders";
import { immutableUpdate } from "lib/immutableUpdate";
import { normalizeKerningOverrides } from "lib/kerning";

const table2Process = element => {
  element = deepFreeze(element);

  let table = { ...element };

  table = bordersProcess(table);
  table = kerningOverridesProcess(table);

  if (!table.lockedCellIds) table.lockedCellIds = [];

  return table;
};

const bordersProcess = table => {
  let updatedTable = { ...table };

  Object.keys(updatedTable.cells).forEach(cellId => {
    const cell = updatedTable.cells[cellId];
    const newBorders = new Table2Borders(cell.borders);
    updatedTable = immutableUpdate(updatedTable, {
      cells: {
        [cellId]: {
          $merge: { borders: newBorders }
        }
      }
    });
  });

  return updatedTable;
};

// Run normalizeKerningOverrides on every cell that has a kerningOverrides
// field; drop the field when empty/malformed so the renderer hot path can
// short-circuit on identity transform. Batches all per-cell updates into one
// immutableUpdate so a wide table doesn't pay O(N) clone cost.
const kerningOverridesProcess = table => {
  const cells = table.cells || {};
  const cellsSpec = {};
  Object.keys(cells).forEach(cellId => {
    const cell = cells[cellId];
    if (!cell || !("kerningOverrides" in cell)) return;
    const normalized = normalizeKerningOverrides(cell.kerningOverrides);
    if (normalized) {
      cellsSpec[cellId] = { $merge: { kerningOverrides: normalized } };
    } else {
      cellsSpec[cellId] = { $unset: ["kerningOverrides"] };
    }
  });
  if (Object.keys(cellsSpec).length === 0) return table;
  return immutableUpdate(table, { cells: cellsSpec });
};

export default table2Process;
